import { useGetVenueList } from 'lib/services/organizations.service'
import type {
	IVenueList,
	VenueDetail,
	VenueProperties
} from 'models/organizations'
import type { Venue } from 'models/venue'
import { useEffect, useState } from 'react'

export interface IUniqueVenues extends VenueDetail {
	list: IVenueList[]
	id: string
	properties: VenueProperties
	venue: Venue
}

const getUniqueVenues = (venueLists: IVenueList[]) => {
	const result: IUniqueVenues[] = []
	for (const venueList of venueLists) {
		for (const venueDetail of venueList.venues) {
			if (result.some(item => item.id === venueDetail.id)) {
				result
					.find(item => item.id === venueDetail.id)
					?.list.push({ ...venueList })
			} else {
				result.push({
					...venueDetail,
					id: venueDetail.id,
					list: [venueList],
					properties: venueDetail.properties,
					venue: venueDetail
				})
			}
		}
	}
	return result
}

const useVenueLists = (organizationId: string) => {
	const [venueLists, setVenueLists] = useState<IVenueList[]>([])
	const [uniqueVenues, setUniqueVenues] = useState<IUniqueVenues[]>([])
	const { data, isFetching, refetch } = useGetVenueList(
		organizationId,
		organizationId !== ''
	)

	useEffect(() => {
		if (data) {
			setVenueLists(data)
			const uniqueVenuesData = getUniqueVenues(data)
			setUniqueVenues(uniqueVenuesData)
		}
	}, [data])

	return { venueLists, setVenueLists, uniqueVenues, isFetching, refetch }
}

export default useVenueLists
